
<template>
  <div id="page-ticket-view">
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />
      <vx-card>
     <template slot="no-body">

        <div class="item-content">

        <div class="product-details p-6">
            <div class="vx-row mt-6">
              <div class="vx-col w-full">
                <h3>{{ticket.name}}  {{ticket.ticket_number}}</h3>
                <p class="my-2">
                  <span class="mr-2">by</span>
                  <span>{{ticket.created_by.fname}} {{ticket.created_by.lname}} | {{ ticket.created_at | formatDate}}</span>
                </p>
                <p class="flex items-center flex-wrap">
                  <vs-chip :color="ticket.status.color"  class="leading-none font-medium">{{ticket.status.name}}</vs-chip>
                  <vs-chip  class="leading-none font-medium">{{ticket.category.name}}</vs-chip>
                </p>
                  <!-- <p class="flex items-center flex-wrap mt-3">
                  <span class="cursor-pointer leading-none ont-semibold font-medium">Created :  </span>
                  <span class="ml-1">{{ ticket.created_at | formatDate}}</span>
                </p> -->
                   <!-- <p class="flex items-center flex-wrap mt-3">
                  <span class="cursor-pointer leading-none ont-semibold font-medium">Category :  </span>
                  <span class="ml-1">{{ticket.category.name}}</span>
                </p> -->
                <vs-divider />
                <p>{{ticket.description}}</p><br>
                   <span v-for="(file, index ) in ticket.attachment" :key="index">
                <!-- <vs-chip closable  class="leading-none font-medium" ><a target="_blank" :href="file.storage_link">{{file.orignal_name}}</a></vs-chip> -->
                <vs-chip closable @click="removeFile(file.id)" class="leading-none font-medium" color="primary" >
                  <span @click="downloadFile(file.file_name)" class="cursor-pointer">{{file.orignal_name}}</span>
                  <!-- <a target="_blank" :href="file_cdn+'file/'+file.file_name">{{file.orignal_name}}</a> -->
                  </vs-chip>
            </span>
                <vs-divider />
                 <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-if="hasRole" @click="editData(ticket)">{{ $t('common.edit') }}</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-if="hasRole" @click="confirmDeleteRecord(ticket)">{{ $t('common.delete') }}</vs-button>
          </div>
        </div>
        </div>
        </div>
        </div>
        </template>
      </vx-card>
      <br>
         <div class="vx-row">

            <!-- CARD 8: Activity Timeline -->
            <div class="vx-col w-full lg:w-1/1 mb-base">
          <vx-card title="Post Update">
            <!-- <vx-card title="Comment"> -->
                      <vs-textarea  placeholder="Write Something" v-model="dataComment" name="description" v-validate="'required'"/>

                     <span  :id="'div-with'" class="vs-con-loading__container flex" :ref="'div-with'">
                        <label for="" class="mr-5">Attach a File</label>
                        <input type="file" multiple  ref="file"   @change="uploadFile()" accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.ppt,.csv,.txt,.bmp,.pdf" >
                     </span>

                      <vs-button style="float:right" :disabled="!isFormValid"  color="success" @click="submitComment(ticket)">Submit</vs-button><br>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
             <span v-for="(file, index ) in uplodedfiles" :key="index">
              <vs-chip @click="removeUploadfile(index)"  closable   class="leading-none font-medium">{{file.orignal}}</vs-chip>
            </span>
            </vs-col>
         </vs-row><br v-if="uplodedfiles.length>0">
          <span v-if="largeFile.length>0" class="text-danger text-sm">Large Files</span><br>
          <vs-row v-if="largeFile.length>0">
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
             <ul v-for="(file, i ) in largeFile" :key="i">
               <li>
                 <vs-chip class="leading-none font-medium">{{file}}</vs-chip>
                </li>
            </ul>
            </vs-col>
            </vs-row><br v-if="largeFile.length>0">

                <!-- </vx-card> -->
          <!-- <vs-textarea label="Write a comment" v-model="dataComment" name="description" v-validate="'required'"/> -->
          <!-- <vs-button style="float:right" :disabled="!isFormValid" size="small" color="success" @click="submitComment(ticket)">Submit</vs-button><br> -->
        <h3>Timeline</h3>
        <ul class="vx-timeline mt-1">
        <li v-for="item in ticket.history" :key="item.title">
          <div  class="timeline-icon p-0">
              <vs-avatar v-if="item.created_by.avatar" class="user-profile-img" size="35px" :src="img_cdn + item.created_by.avatar"/>
              <p v-else class="bg-primary commentdot text-white" :data-lettercomment=item.created_by.fname[0].toUpperCase()></p>

          </div>
          <div class="timeline-info">
              <p class="font-semibold">{{ item.created_by.fname }} {{ item.created_by.lname }}</p>
              <span class="activity-desc" v-html="item.description"></span>
          </div>
            <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
             <span v-for="(file, index ) in item.attachment" :key="index">
              <!-- <vs-chip  class="leading-none font-medium" ><a target="_blank" :href="file.storage_link">{{file.orignal_name}}</a></vs-chip> -->
                  <vs-chip v-if="file.deleted_at==null" class="leading-none font-medium" color="primary">
                  <!-- <a target="_blank" :href="file_cdn+'file/'+file.file_name">{{file.orignal_name}}</a> -->
                  <span @click="downloadFile(file.file_name)" class="cursor-pointer">{{file.orignal_name}}</span>
                  </vs-chip>
                <vs-chip v-else class="leading-none font-medium" >
                  <!-- <a target="_blank" :href="file_cdn+'file/'+file.file_name">{{file.orignal_name}}</a> -->
                  <span  class="cursor-pointer">{{file.orignal_name}}</span>
                  </vs-chip>
            </span>
            </vs-col>
               </vs-row>

          <small class="text-grey activity-e-time">{{ item.summary }}</small>
          <small class="text-grey activity-e-time ml-2">{{ item.created_at | formatDate}}</small>

      </li>
      </ul>
        </vx-card>
            </div>
        </div>
        <!-- <div class="flex flex-wrap-reverse items-center data-list-btn-container mt-5">
       <h3 class="ml-5">History</h3>
        </div> -->
        <!-- <vs-textarea class="mt-1" label="" v-model="dataDetail" name="description" v-validate="'required'"/>
            <vs-button color="primary">Submit</vs-button> -->
<!--
        <p v-if="ticket.history.length==0" class="ml-5 text-left mt-5">No history associate to this ticket</p>
       <div   v-if="ticket.history.length>0" class="data-list-container p-6">
       <vs-table ref="table"  :data="ticket.history">
        <template slot="thead">
        <vs-th>Summary</vs-th>
        <vs-th>Discription</vs-th>
        <vs-th>Action BY</vs-th>
       </template>
       <template  slot-scope="{data}">
          <tbody>
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.summary }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.description }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.created_by.username }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>  -->


</div>
</template>
<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moment from 'moment'
import {
  ADD_TICKET_COMMENT,
  DOWNLOAD_TICKET_ATTACHMENT,
  GET_SINGLE_TICKET,
  ME_DATA,
  REMOVE_TICKET,
  REMOVE_TICKET_ATTACHMENT
} from "@/graphql";
import VxTimeline from '@/components/timeline/VxTimeline'
import S3 from 'aws-s3';

const config = {
    bucketName: process.env.VUE_APP_AWS_BUCKET,
    dirName: process.env.VUE_APP_AWS_DIREC,
    region: process.env.VUE_APP_AWS_DEFAULT_REGION,
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
    s3Url: process.env.VUE_APP_AWS_s3Url
}
 const S3Client = new S3(config);

export default{
components: {
      'DataViewSidebar': DataViewSidebar,
      VxTimeline


  },
  data () {
    return {
      ticket: [],
      meID: '',
      img_cdn: '',
      dataComment: '',
      uplodedfiles: [],
      file_cdn: '',
      addNewDataSidebar: false,
      sidebarData: {},
      DeletedItem: '',
      largeFile: [],
      userRolePermissions: [],
      hasRole: false,


    }
  },
  filters:{
  formatDate: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY h:mm A')
  }
  },
  formatTime: function (value) {
    if (value) {
     return moment(String(value),'h:mm A').format('h:mm A')
  }
  },
},
computed:{
    isFormValid () {
    return !this.errors.any() && this.dataComment
    },

},
methods: {
  downloadFile(file){
      this.$apollo
      .mutate({
        mutation: DOWNLOAD_TICKET_ATTACHMENT,
        variables: {
        file: file,
     },
      })
        .then(response => {
          window.location = response.data.downloadTicketAttachment;
          this.get()

      }
        )
  },
  removeUploadfile(file){
    this.uplodedfiles.splice(file, 1)
  },
  removeFile(file){
     this.$apollo
      .mutate({
        mutation: REMOVE_TICKET_ATTACHMENT,
        variables: {
        id: file,
     },
      })
        .then(response => {
          this.StatusSuccess('File Remove Successfully')
          this.get()

      }
        )
  },
    getdata(value){
     if(value){
       this.get()
     }
     },
   addNewTicket(){
      this.sidebarData = {}
      this.toggleDataSidebar(true)
  },
  toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
   editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
   openLoadingInDiv(){
      this.$vs.loading({
        type:'sound',
        container: '#div-with',
        scale: 0.6
      })
    },
  uploadFile(){
        var largeFile=[]
        for( var i = 0; i < this.$refs.file.files.length; i++ ){
        let limit = 1024 * 1024 * 2048;
          if(this.$refs.file.files[i].size > limit){
             largeFile.push(this.$refs.file.files[i].name)
          }
          else{
             let file = this.$refs.file.files[i];
              let orignal_name=this.$refs.file.files[i].name
              let name=Math.random().toString().slice(2)
              this.openLoadingInDiv();
              S3Client
             .uploadFile(file,name)
             .then(response => {
               this.$vs.loading.close(`#div-with > .con-vs-loading`)
               this.SaveFile(response,orignal_name)
            })
             .catch(err => console.error(err))
          }
     this.largeFile=largeFile
    }
    // this.openLoadingInDiv();
    // let formData=[];
    // for( var i = 0; i < this.$refs.file.files.length; i++ ){
    //     let file = this.$refs.file.files[i];
    //     formData.push(file);
    // }
  //  if (input.target.files && input.target.files[0]) {
        // let limit = 1024 * 1024 * 20;
        //   if(input.target.files[0].size > limit){
        //     this.sizemessage()
        //     return false
        //   }
        // const reader = new FileReader()
        //  reader.onload = e => {
        //   this.dataFile = e.target.result
        //   console.log(e.target.result)
          // this.$apollo
          //   .mutate({
          //     mutation: UPLOAD_FILE,
          //     variables: {
          //       file: formData,
          //     }
          //   })
          //   .then(response => {
          //     if (response) {
          //       var files=response.data.uploadFile.files
          //       for (let i = 0; i < files.length; i++) {
          //         this.uplodedfiles.push(files[i])

          //       }
          //       this.$vs.loading.close(`#div-with > .con-vs-loading`)
          //     }
          //   }).catch(error => {
          //   console.log(error)
          // });
      //   }
      //   reader.readAsDataURL(input.target.files[0])
      // }
  },
   SaveFile(response,orignal_name){

          if(response){
                  this.uplodedfiles.push({
                 'orignal':orignal_name,
                 'new':response.key,
                 'link':response.location
                })
               }

  },
  submitComment(ticket){
      this.$apollo
      .mutate({
        mutation: ADD_TICKET_COMMENT,
        variables: {
        id: ticket.id,
        comment:this.dataComment,
        comment_by:this.meID,
        files:this.uplodedfiles,
     },
      })
        .then(response => {
          this.dataComment=null
          this.uplodedfiles=[]
          this.$refs.file.value=null;
          this.get()

      }
        )

  },
   confirmDeleteVideoRecord (data) {
      this.DeletedItem=data
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this video`,
        accept: this.removeVideoData,
        acceptText: 'Delete'
      })
    },
  removeVideoData(){
      this.$apollo
      .mutate({
        mutation: DELETE_INCIDENT_SINGLE_VIDEOS,
        variables: {
        id: this.DeletedItem.id,
     },
      })
        .then(response => {
          console.log(response)
          this.get()

      }
        )




  },
  getdataa(value){
   if(value){
     this.get()
   }
  },
      confirmDeleteRecord (ticket) {
      this.DeletedItem=ticket.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.ticket.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
     deleteData() {
     this.$apollo
      .mutate({
        mutation: REMOVE_TICKET,
        variables: {
        id: this.DeletedItem,
     },
      })
      .then(response => {
              if (response) {
                this.StatusSuccess('Delete Successfully')
                this.$router.push('/tickets')
            }
            }).catch(error => {
            console.log(error)
          });

     },
      StatusSuccess(note) {
      this.$vs.notify({
        title: "Ticket",
        text:   note,
        color:  'success',
        position: 'top-right'
      })
      },
   get(){
    this.$apollo
      .mutate({
        mutation: GET_SINGLE_TICKET,
        variables: {
        id: this.$route.params.ticketId,
     },
      })
        .then(response => {

        // console.log( response.data.ticket.history.sort(function(a, b){return b.created_at - a.created_at}) );

          this.ticket=response.data.ticket

          this.ticket.history = response.data.ticket.history.sort(function(a, b){return b.id - a.id})
      }
        )
        }

  },
created(){
    this.file_cdn=process.env.VUE_APP_SERVER_HTTP_URL
      this.$apollo
        .query({
          query: ME_DATA,
        })
        .then((response) => {
          this.meID=response.data.me.id

      }) .catch(error => {
          console.log(error)
      });
      this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    // const userRoles = JSON.parse(localStorage.getItem('user-roles'))
    // this.role=userRoles[0]['name']
    this.get()
  this.$apollo
    .query({
      query: ME_DATA,
    })
    .then((response) => {
      this.userRolePermissions = response.data.me.roles[0].permissions
      var exists = this.userRolePermissions.some(function(permission) {
        return permission.name === "edit_tickets"
      });
      if(exists){
        this.hasRole=true
      }
      else {
        this.hasRole=false

      }
    }).catch((error) => {
    // window.location = '/login'
    console.log(error)
  });

}
  }
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
<style >
 [data-lettercomment]:before {
  content:attr(data-lettercomment);
  }
  .commentdot{
  display:inline-block;
  font-size:20px;
  width:35px;
  height:35px;
  line-height:38px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  }
</style>
